import React, { ReactElement, Children, cloneElement } from 'react';
import { ColumnProps } from './Column';
import { classNames } from '../../utils/style';

export type RowProps = {
  template?: templateRowProps;
  children: ReactElement<ColumnProps> | ReactElement<ColumnProps>[];
};

export type templateRowProps =
  | 'full'
  | 'half'
  | 'third'
  | 'spotleft'
  | 'spotright';

const templateClass = (template?: templateRowProps): string[] => {
  if (template === 'full') return ['lg:w-full'];
  if (template === 'half') return ['lg:w-[calc(50%-19px/2)]'];
  if (template === 'third') return ['lg:w-[calc(100%/3-19px/3)]'];
  if (template === 'spotleft')
    return [
      'lg:w-[calc(678*100%/1202)]',
      'lg:w-[calc(100%-678*100%/1202-20px)]',
    ];
  if (template === 'spotright')
    return [
      'lg:w-[calc(100%-678*100%/1202-20px)]',
      'lg:w-[calc(678*100%/1202)]',
    ];
  return [''];
};

export const Row = ({ template, children }: RowProps) => {
  const templateClasses = templateClass(template);

  return (
    <>
      {Children.map(children, (child, index) =>
        cloneElement(child, {
          className: classNames(
            'Row',
            child.props.className,
            templateClasses[index % templateClasses.length],
            'w-full',
          ),
        }),
      )}
    </>
  );
};
